import React, {Component} from 'react';
import AgencyRevenueService from "../../services/AgencyRevenueService";
import {toast} from 'react-toastify';
import NumberFormat from 'react-number-format';


export default class LYCompensation extends Component {
    state = {
        compensation: 0,
        disableSaveButton: true
    }

    componentDidMount = () => {
        if (this.props.plListProfile) {
            this.getInitialState();
        }
    };

    getInitialState = async () => {
        const result = await AgencyRevenueService.getCompensationPaid(
            this.props.plListProfile
        );
        this.setState({
            compensation: result.data.pl_profile.ly_compensation_paid
        })
    };

    handleChange = (values) => {
        const {floatValue} = values;
        this.setState({disableSaveButton: false, compensation: floatValue});
    };

    cancelChange = () => {
        this.setState({disableSaveButton: true, compensation: 0});
        this.props.cancelLYCompensation();
    };

    save = async () => {
        if (!this.state.disableSaveButton) {
            try {
                let data = {
                    ly_compensation_paid: this.state.compensation
                };
                await AgencyRevenueService.savecompensationPaid(data, this.props.plListProfile);
                this.setState({disableSaveButton: true});

                toast.success("Saved Successfully.", {
                    position: toast.POSITION.TOP_CENTER
                });
            } catch (error) {
                toast.error("Please try to save again.", {
                    position: toast.POSITION.TOP_CENTER
                });
            }

        }
    };

    render = () => {
        const {compensation} = this.state;
        const {isOldProfile} = this.props;

        return (
            <fieldset className="card card-body pt-1">
                <legend className="mb-0 pb-1" style={{width:"fit-content"}}>
                    <small><small>Last Year Compensation Paid &nbsp;</small></small>
                </legend>
                <div className="row">
                    <div className="col-5 col-sm-3">
                        <NumberFormat type="tel" value={compensation}  
                            thousandSeparator={true} prefix={'$ '} 
                            decimalScale={0} allowNegative={false} 
                            onValueChange={(values) => this.handleChange(values)} 
                            className="form-control text-center" name="ly_compensation" 
                            disabled={isOldProfile}
                        />
                    </div>
                    {!isOldProfile && (
                        this.props.permission.can_add || this.props.permission.can_edit
                    ) &&
                        <div className="col-1">
                            <button className="btn btn-success" onClick={this.save}>Save</button>
                        </div>
                    }
                    <div className="col-1">
                        <button className="btn btn-warning" onClick={this.cancelChange}> Close </button>
                    </div>
                </div>
            </fieldset>
        );
    };
}


// WEBPACK FOOTER //
// ./src/components/agencyRevenue/LYCompensation.js